import { useState, useEffect } from 'react'

export const useFetchAllLeaseApplications = ({marvarApi, dispatch, onLogout}) => {
    const [leaseApplications, setLeaseApplications] = useState([])
    const [loadingFetchLeaseApplications, setLoadingFetchLeaseApplications ] = useState(false) //estado para animacion de carga
    
    const [ execute, setExecute ] = useState(false)
    const executeFetchAllLeaseApplications = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/leases/management`)
            // console.log('[useFetchData][useFetchAllLeaseApplications] response.data', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchLeaseApplications(true)
        fetchData()
            .then((resp) => {
                setLeaseApplications(resp.data)
                setLoadingFetchLeaseApplications(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchLeaseApplications(false)
            })
    }, [execute])

    return { leaseApplications, loadingFetchLeaseApplications, executeFetchAllLeaseApplications }

}

export const useFetchInfoLease = ({marvarApi, dispatch, onLogout, Forms}) =>{
    const { FormLeases } = Forms
    const { setFormState } = FormLeases

    // 2. Para mostrar animación de carga
    const [ loadingFetchInfoLease, setLoadingFetchInfoLease ] = useState(false)

    // 3. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({})

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetchInfoLease = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/leases/common/application/${paramsToSearch.idcontrato}`)
            // console.log('[useFetchData][useFetchInfoLease] response.data ::: ', response)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idcontrato > 0 ){
            setLoadingFetchInfoLease(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp
                    const { idcasa, costo_alquiler } = data
                    const idhouse = JSON.stringify({ idcasa, costo_alquiler })
                    setFormState((prevState) => ({
                        ...prevState,
                        idcontrato: data.idcontrato || '',
                        idcasa: idhouse || '',
                        idcliente: data.idcliente || '',
                        contrato_fecha: data.contrato_fecha || '',
                        contrato_dia_pago: data.contrato_dia_pago || '',
                        contrato_plazo_meses: data.contrato_plazo_meses || '',
                        contrato_costo_alquiler: data.contrato_costo_alquiler || '',
                        contrato_costo_alquiler_mask: parseFloat(data.contrato_costo_alquiler).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '',
                        contrato_total_alquiler: data.contrato_total_alquiler || '',
                        contrato_total_alquiler_mask: parseFloat(data.contrato_total_alquiler).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '',
                        contrato_papeleria: data.contrato_papeleria || '',
                        contrato_papeleria_mask: parseFloat(data.contrato_papeleria).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '',
                        contrato_deposito: data.contrato_deposito || '',
                        contrato_deposito_mask: parseFloat(data.contrato_deposito).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '',
                        contrato_observaciones: data.contrato_observaciones || '',
                        aprobacion_check: data.aprobacion_check || '',
                        aprobacion_observaciones: data.aprobacion_observaciones || '',
                        aprobacion_fecha: data.aprobacion_fecha || '',
                        // usuario_creo: user.username,
                        // fecha_creo: dateNow
                    }))
                    setLoadingFetchInfoLease(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchInfoLease(false)
                })
        }
    }, [execute])

    return { loadingFetchInfoLease, setParamsToSearch, executeFetchInfoLease }
}

export const useFetchInfoDeposit = ({marvarApi, dispatch, onLogout, Forms, pdfManager, Helpers}) => {
    
    const defaultParams = {
        iddeposit: '',
        printTicketFlag: false
    }

    const { FormDeposit } = Forms
    const { setFormState } = FormDeposit
    
    const [paramsToSearch, setParamsToSearch] = useState(defaultParams)
    
    const [ loadingInfoDeposit, setLoadingInfoDeposit ] = useState(false)
    
    const [ execute, setExecute ] = useState(false)
    const executeFetchInfoDeposit = async () => {
        setExecute(!execute)
    }

    const resetFetch = async () => {
        setParamsToSearch(defaultParams)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/leases/common/get-deposit-by-ID/${paramsToSearch.iddeposit}`)
            // console.log('[useFetchData][useFetchInfoDeposit] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.iddeposit > 0 ){
            setLoadingInfoDeposit(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        iddeposit: data.iddeposit || '',
                        idcaja : data.idcaja || '',
                        idbanco : data.idbanco || '',
                        boleta_numero : data.boleta_numero || '',
                        boleta_foto_path : data.boleta_foto_path || '',
                        boleta_foto_originalname : data.boleta_foto_originalname || '',
                        aprobacion_referencia_ach : data.aprobacion_referencia_ach || '',
                        aprobacion_observaciones : data.aprobacion_observaciones || '',
                        aprobacion_check : data.aprobacion_check || '',
                        deposito_dolares : data.deposito_dolares || '',
                        deposito_fecha : data.deposito_fecha || '',
                        deposito_moneda : data.deposito_moneda || '',
                        deposito_monto : data.deposito_monto || '',
                        deposito_monto_mask: parseFloat(data.deposito_monto).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '',
                        deposito_observaciones : data.deposito_observaciones || '',
                        deposito_quetzales : data.deposito_quetzal || '',
                        deposito_tipo_cambio : data.deposito_tipo_cambio || '',
                        movimiento_tipo : data.movimiento_tipo || ''
                    }))

                    if (paramsToSearch?.printTicketFlag === true){
                        console.log('imprimiendo PDF')
                        Helpers.drawDepositTicket(pdfManager, data)
                    }
                    setLoadingInfoDeposit(false)
                })
                .catch(e => {
                    setLoadingInfoDeposit(false)
                    console.log(e, '________ERROR')
                })
        }
    }, [execute])

    return { loadingInfoDeposit, setParamsToSearch, executeFetchInfoDeposit, resetFetch}
}

export const useFetchAllHouses = ({marvarApi, dispatch, onLogout}) =>{

    // 1. Para almacenar las casas
    const [houses, setHouses] = useState([])

    // 2. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetchAllHouses = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/leases/common/get-houses`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp

                    setHouses(data)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
    }, [execute])

    return { houses, executeFetchAllHouses }
}

export const useFetchAllCustomers = ({marvarApi, dispatch, onLogout}) =>{

    // 1. Para almacenar las casas
    const [customers, setCustomers] = useState([])


    // 2. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetchAllCustomers = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/leases/common/get-customers`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp
                    
                    setCustomers(data)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
    }, [execute])

    return { customers, executeFetchAllCustomers }
}

export const useFetchAllDeposits= ({marvarApi, dispatch, onLogout, Forms}) => {
    const [deposits, setDeposits] = useState([])
    const [loadingFetchDeposits, seteLoadingFetchDeposits ] = useState(false) //estado para animacion de carga
    
    const {FormLeases} = Forms
    const {formState} = FormLeases


    const [ execute, setExecute ] = useState(false)
    const executeFetchAllDeposits = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/leases/common/get-deposit/${formState.idcontrato}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(formState.idcontrato > 0 ){
            seteLoadingFetchDeposits(true)
            fetchData()
                .then((resp) => {
                    setDeposits(resp.data)
                    seteLoadingFetchDeposits(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    seteLoadingFetchDeposits(false)
                })
        }
    }, [execute])

    return { deposits, loadingFetchDeposits, executeFetchAllDeposits }

}

export const useFetchAllCashRegisters= ({marvarApi, dispatch, onLogout}) => {
    const [cashRegisters, setCashRegisters] = useState([])
    

    const [ execute, setExecute ] = useState(false)
    const executeFetchAllCashRegisters = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/leases/common/all-cajas`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
            fetchData()
                .then((resp) => {
                    const { data } = resp
                    setCashRegisters(data)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
    }, [execute])

    return { cashRegisters, executeFetchAllCashRegisters }
}

export const useFetchAllBanks= ({marvarApi, dispatch, onLogout}) => {
    
    const [banks, setBanks] = useState([])

    const [ execute, setExecute ] = useState(false)
    const executeFetchAllBanks = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/leases/common/all-bancos`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
            fetchData()
                .then((resp) => {
                    const { data } = resp

                    setBanks(data)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
    }, [execute])

    return { banks, executeFetchAllBanks }
}

export const useFetchAllFiles = ({marvarApi, dispatch, onLogout, Forms}) =>{
    const { FormFiles, FormLeases } = Forms
    const { setFormState } = FormFiles
    const formStateLeases = FormLeases.formState

    // 1. Para mostrar animación de carga
    const [ loadingFetchInfoFiles, setLoadingFetchInfoFiles ] = useState(false)

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(0)
    const executeFetchAllFiles = async () => {
        setExecute(currentCount => currentCount + 1)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/leases/common/get-documents/${formStateLeases.idcontrato}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    

    useEffect(() => {
        if(formStateLeases.idcontrato > 0 ){
            setLoadingFetchInfoFiles(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp

                    setFormState((prevState) => ({
                        ...prevState,
                        files: data
                    }))

                    setLoadingFetchInfoFiles(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchInfoFiles(false)
                })
        }
    }, [execute])

    return {loadingFetchInfoFiles, executeFetchAllFiles }
}

export const useFetchAllObservations = ({marvarApi, dispatch, onLogout, Forms, pdfManager, Helpers}) => {
    
    const defaultParams = {
        idcontrato: ''
    }
    
    const [ paramsToSearch, setParamsToSearch ] = useState(defaultParams)

    const [ dataObservations, setDataObservations ] = useState([])
    
    const [ loadingFetchObservations, setLoadingFetchObservations ] = useState(false)
    
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const resetFetch = async () => {
        setParamsToSearch(defaultParams)
        setDataObservations([])
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/leases/common/fetch-all-observations/${paramsToSearch.idcontrato}`)
            // console.log('[useFetchData][useFetchAllObservations] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idcontrato > 0 ){
            setLoadingFetchObservations(true)
            fetchData()
                .then((resp) => {
                    console.log('resp.rows ::: ', resp.rows)
                    setDataObservations(resp.rows)
                    setLoadingFetchObservations(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setDataObservations([])
                    setLoadingFetchObservations(false)
                })
        }
    }, [execute])

    return { loadingFetchObservations, dataObservations, setParamsToSearch, executeFetch, resetFetch}
}